// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#006cfd","colorPrimaryLight5":"#80b6fe","colorPrimaryLight7":"#b3d3fe","colorPrimaryLight9":"#e6f0ff"};